import { useRouter } from 'next/router';
import { EmployeeCmdK } from './EmployeeCmdK';
import { useCmdKShortcut } from './hooks';
import { RegularCmdK } from './RegularCmdK';

/**
 * Main entry point for the Cmd+K command palette.
 * Detects context (employee vs regular user) and renders the appropriate variant.
 */
export function CmdKSwitcher({
  dbUser,
  isSignedIn,
}: {
  dbUser: { id: string } | null;
  isSignedIn: boolean;
}) {
  const { open, onOpenChange } = useCmdKShortcut();
  const router = useRouter();

  const isEmployeeContext = router.pathname.startsWith('/employee');

  if (isEmployeeContext) {
    return <EmployeeCmdK open={open} onOpenChange={onOpenChange} />;
  }

  return (
    <RegularCmdK
      open={open}
      onOpenChange={onOpenChange}
      dbUser={dbUser}
      isSignedIn={isSignedIn}
    />
  );
}
